import {DateAdapter, MAT_DATE_FORMATS} from "@angular/material/core";
import {MomentDateAdapter} from "@angular/material-moment-adapter";
import {CUSTOM_YEAR_FORMAT} from "../formats/custom-date.format";

export const customYearProvider = [
  {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
  },
  {
    provide: MAT_DATE_FORMATS,
    useValue: CUSTOM_YEAR_FORMAT
  }
]
